import { render, staticRenderFns } from "./operationDetails.vue?vue&type=template&id=2f61cb84&scoped=true"
import script from "./operationDetails.vue?vue&type=script&lang=js"
export * from "./operationDetails.vue?vue&type=script&lang=js"
import style0 from "./operationDetails.vue?vue&type=style&index=0&id=2f61cb84&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f61cb84",
  null
  
)

export default component.exports